import { useTranslation } from 'react-i18next';
import { StepCardOld } from 'pages/AutomationEngine/Engine/Steps/StepCardOld';

type StepProps = {
  step: {
    details: any;
  };
  color: string;
  title: string;
};

export default function RunGetRequestsCard({
  step,
  color,
  title,
  ...others
}: StepProps) {
  const { t } = useTranslation();
  return (
    <StepCardOld
      {...others}
      id={step.details.id}
      color={color}
      showMovingPlaceholder={false}
      title={title}
      panel={null}
      editOnly
    >
      {t('Retrieve {{#}} Payloads', {
        interpolation: { prefix: '{{{', suffix: '}}}' },
      })}
    </StepCardOld>
  );
}
